"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComponentGlobals_1 = require("./ComponentGlobals");
var dispatchWindowResizeImmediate = function () {
    ComponentGlobals_1.ComponentGlobals.ignoreResize = true;
    try {
        var event = document.createEvent("Event");
        event.initEvent("resize", true, true);
        window.dispatchEvent(event);
    }
    finally {
        ComponentGlobals_1.ComponentGlobals.ignoreResize = false;
    }
};
var dispatchWindowResize = function () {
    // may need to debounce this in the future
    dispatchWindowResizeImmediate();
};
exports.dispatchWindowResize = dispatchWindowResize;
